import {Component, OnInit, ViewChild} from '@angular/core';
import {Subject, Subscription} from "rxjs";
import {DataTableDirective} from "angular-datatables";
import {UserDataStoreService} from "../services/user-data-store.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ParticipantViewModel} from "../models/participant-view-model";
import {ParticipantService} from "../services/participant.service";
import { ToastrService } from 'ngx-toastr';
import { PermissionEnum } from '../services/guards/permissions';
import {AuthenticationService} from "../services/authentication.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-participant-management',
  templateUrl: './participant-management.component.html',
  styleUrls: ['./participant-management.component.scss']
})
export class ParticipantManagementComponent implements OnInit {
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<boolean> = new Subject();
  public participants: ParticipantViewModel[] = [];
  public canEdit: boolean;


  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  constructor(
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _participantService: ParticipantService,
    private _toastService: ToastrService) {
    this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditParticipantConfiguration], []);

  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
  }

  public async ngAfterViewInit(): Promise<void> {
    await this.init();
  }

  private async init(): Promise<void> {
    this.participants = await this._participantService.GetAllParticipants();
    this.dtTrigger.next();
  }

  private resetDatatable(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public async syncParticipants(): Promise<void>{
    await this._participantService.Sync();
    this.participants = await this._participantService.GetAllParticipants();
    this.resetDatatable();
  }

  public editParticipant(participant: ParticipantViewModel): void {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this._router.navigate(['management', 'participant', 'edit', participant.id]);
    }
  }

  public editSinkNode(participant: ParticipantViewModel): void {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this._router.navigate(['management', 'participant', 'editSinkNodes', participant.id]);
    }
  }

  public editCardSets(participant: ParticipantViewModel): void {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this._router.navigate(['management', 'participant', 'editCardSets', participant.id]);
    }
  }

  public editProductProfiles(participant: ParticipantViewModel): void {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this._router.navigate(['management', 'participant', 'editProductProfiles', participant.id]);
    }
  }

  public editTerminalCapabilities(participant: ParticipantViewModel): void {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this._router.navigate(['management', 'participant', 'editTerminalCapabilities', participant.id]);
    }
  }

  public editCommsProfile(participant: ParticipantViewModel): void {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this._router.navigate(['management', 'participant', 'editCommsProfile', participant.id]);
    }
  }

  public editCustomTags(participant: ParticipantViewModel): void {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this._router.navigate(['management', 'participant', 'editCustomTag', participant.id]);
    }
  }

  public editVAS(participant: ParticipantViewModel): void {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this._router.navigate(['management', 'participant', 'editVAS', participant.id]);
    }
  }

  public merchantMigration(participant: ParticipantViewModel): void {
    if (!this.canEdit) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {
      this._router.navigate(['management', 'participant', 'merchantMigration', participant.id]);
    }
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
}
